import { render, staticRenderFns } from "./editGrade.vue?vue&type=template&id=aaa23f88&scoped=true&"
import script from "./editGrade.vue?vue&type=script&lang=js&"
export * from "./editGrade.vue?vue&type=script&lang=js&"
import style0 from "./editGrade.vue?vue&type=style&index=0&id=aaa23f88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaa23f88",
  null
  
)

export default component.exports